export default __webpack_public_path__ + "static/media/signup_bg.903997e6.png";